import { Component } from '@angular/core';
import { BotaoRedeSocialComponent } from '../botao-rede-social/botao-rede-social'
import { BrComService } from '../../service/BrComService'
/**
 * Generated class for the BotaoFacebookComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'botao-facebook',
  templateUrl: '../botao-rede-social/botao-rede-social.html'
})
export class BotaoFacebookComponent extends BotaoRedeSocialComponent{

  protected backgroundColor: string;
  protected icon: string;
  protected label: string;

  constructor(private brcomService: BrComService) {
    super()
    this.backgroundColor = "#3b5998";
    this.icon = "logo-facebook";
    this.label = "Facebook";
  }

  protected async abrirRedeSocial() {
    const load = this.brcomService.criaMensagemLoading()
    await load.present();
    await this.brcomService.facebook(this.link);
    load.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/botao-facebook/botao-facebook.ts